import { gql } from './apollo';

export const GET_SETTINGS = gql`
    query {
        settingsList {
            edges {
                node {
                    id
                    setting
                    value
                }
            }
        }
    }
`;

export const GET_SETTING_BY_KEY = gql`
    query ($key: String!) {
        settingsList(key: $key) {
            edges {
                node {
                    id
                    setting
                    value
                }
            }
        }
    }
`;
